window.addEventListener('popstate', (event) => {
  if (event.state && event.state.page) {
    fetch(event.state.page)
      .then((response) => response.text())
      .then((html) => {
        // Обновляем содержимое страницы
        const container = document.createElement('div');
        container.innerHTML = html;
        document.querySelector('html').innerHTML = container.innerHTML;

        // Выполняем скрипты в загруженном HTML
        const scripts = container.querySelectorAll('script');
        scripts.forEach((script) => {
          const scriptContent = `
            (function() {
              ${script.textContent}
            })();
          `;
          const newScript = document.createElement('script');
          newScript.text = scriptContent;
          document.head.appendChild(newScript);
        });
      });
  }
});

/**
 * Реализует эффект "липкости" для выбранного элемента при прокрутке страницы.
 * Элемент становится фиксированным на экране, когда пользователь прокручивает страницу до определенной точки.
 */
window.addEventListener('scroll', function () {
  if (!document.querySelector('.fixedRow')) return;
  var parent = document.querySelector('.fixedRow').parentNode;
  var element = document.querySelector('.fixedRow'); // Ваш элемент
  var stickyTriggerPoint = 10; // Расстояние от верха окна браузера до момента активации стики-эффекта

  var parentOffsetTop = parent.offsetTop; // Расстояние от родителя до верха документа
  var windowHeight = window.innerHeight; // Высота окна браузера
  var scrollPos = window.scrollY; // Текущая позиция прокрутки

  if (scrollPos - element.offsetHeight > parentOffsetTop) {
    $(element).addClass('fixed');
    element.setAttribute('style', `width:${parent.offsetWidth}px`);
    parent.setAttribute('style', `height:${element.offsetHeight + 20}px`);
  } else {
    $(element).removeClass('fixed');
  }
});

document.addEventListener('click', (e) => {
  if (e.target.closest('.disable-focus')) {
    e.target.blur(); // Убираем фокус
    const fullScreenElement = document.querySelector('.fullScreenElement');
    if (fullScreenElement) {
      fullScreenElement.focus(); // Переключаем класс
    }
  }
});


const headerUrl = (function() {
  const header = new Headers(document.cookie.split(';')
    .map(v => v.trim().split('='))
    .map(([k, v]) => [k, decodeURIComponent(v)]));
  return header.get('X-New-Url');
})();

if (headerUrl) history.replaceState(null, '', headerUrl);